import React from "react";

const FAQS = [
  {
    q: "How do I know the AI’s answers are accurate?",
    a: "Every statement in a research brief is linked to its source citation, so you can open the judgment or notification and verify it before relying on it. You choose which sources go into a draft.",
  },
  {
    q: "Is Vedum compliant with the DPDP Act?",
    a: "Yes. Vedum secures personal data in line with the Digital Personal Data Protection Act, 2023 and the DPDP Rules, 2025 — including notice and consent, purpose limitation, reasonable security safeguards, breach intimation, Data Principal rights and retention limits. Client data is never used to train AI models. We can share our data processing terms and security documentation on request.",
  },
  {
    q: "Where does Vedum’s case law come from?",
    a: "Vedum has a strategic partnership with TIOL (taxindiaonline.com) for pruned, curated case law. Working from selected, consistently cited decisions — rather than raw judgments — gives the AI cleaner material and gives you citations you can check in seconds.",
  },
  {
    q: "Where do Legal Insights come from?",
    a: "Insights are computed from the judgments, notifications and circulars behind your research — trends by year, outcomes by forum and groupings by sub-issue — so you see the pattern, not just the list.",
  },
  {
    q: "How are litigation alerts decided?",
    a: "When you create a litigation, Vedum learns its parties, forum, sections and issues, then scores new listings, rulings and notifications for relevance — so you see what matters, ranked, with the reason it was flagged.",
  },
  {
    q: "Does Vedum replace my judgement?",
    a: "No. Vedum accelerates research, drafting and tracking. Legal judgement, strategy and final sign-off remain with you.",
  },
  {
    q: "How long does onboarding take?",
    a: "[Typical onboarding timeline.] Our team helps import existing matters and configure templates for Draft Studio.",
  },
];

const Faq = () => (
  <section className="vd-section">
    <div className="container" style={{ maxWidth: 860 }}>
      <h2 className="vd-h2 mb-4">Questions advocates ask us</h2>
      <div className="vd-faq">
        {FAQS.map((f) => (
          <details key={f.q}>
            <summary>{f.q}</summary>
            <p>{f.a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default Faq;
